/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import Lozenge from '@atlaskit/lozenge';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

export const BetaTag = () => (
	<Lozenge
		style={{
			backgroundColor: token('color.background.neutral'),
			color: token('color.text.subtle'),
		}}
	>
		<FormattedMessage {...messages.beta} />
	</Lozenge>
);
